import {PlugTypeDto} from '../plug/plugType';
import {UserAction} from '../userAction';
import {PricingContextDto} from '../../map/chargeAreaDetailsMarker';
import {Location} from '../../location/location';
import {InfraStatus} from '../../enum/infraStatus';
import {ChargePointDto} from '../chargePoint/chargePoint';
import {AvailabilityMacroStatus} from '../availabilityMacroStatus';

export interface StationDto {
    id?: string;
    visualId?: string;
    alias?: string;
    logoRef?: string;
    address?: Location;
    chargeAreaRef?: string;
    chargeAreaName?: string;
    chargeAreaAddress?: Location;
    reason?: string;
    infraStatus: InfraStatus;

    // Lazy loaded
    chargePoints: ChargePointDto[];
    /**
     * depends on TA, subscriptionPack and ConnectedUser
     */
    userActions?: UserAction[];
    /**
     * depends on TA, subscriptionPack and ConnectedUser and InfraElement Status on the request moment
     */
    currentUserActions?: UserAction[];
    plugTypes?: PlugTypeDto[];
    pricingContext?: PricingContextDto;
    otpAllowedStatuses?: AvailabilityMacroStatus[];
}

export enum StationLazyCategory {
    /**
     * depends on TA, subscriptionPack and ConnectedUser
     */
    USER_ACTIONS = 'USER_ACTIONS',
    /**
     * depends on TA, subscriptionPack and ConnectedUser and InfraElement Status on the request moment
     */
    CURRENT_USER_ACTIONS = 'CURRENT_USER_ACTIONS',
    ALL_PLUG_TYPES = 'ALL_PLUG_TYPES',
    PLUG_TYPES = 'PLUG_TYPES',
    PRICING_CONTEXT = 'PRICING_CONTEXT',
    CHARGE_POINTS = 'CHARGE_POINTS',
    OTP_ALLOWED_STATUSES = 'OTP_ALLOWED_STATUSES',
}
